import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 7.8.",
  "description": "",
  "published": "2011-08-07T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-7-8/swizec/2100"],
  "categories": "California, Learning, Metro Areas, Palo Alto, Personal, San Francisco",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-SF_Chinatown_CA6.jpg",
        "alt": "Grant Ave. in Chinatown, San Francisco.",
        "title": "Grant Ave. in Chinatown, San Francisco."
      }}></img></p>
    <p>{`Today I learned that `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.7793,-122.4192&spn=0.1,0.1&q=37.7793,-122.4192%20(San%20Francisco)&t=h",
        "title": "San Francisco"
      }}>{`San Francisco`}</a>{` is a really awesome city to just ride around on a bike pretty much without a set direction. You get to discover a lot of very interesting things, like this epic breakfast place in Mission called Boogaloos. It is in fact so awesome that there was a whole bunch of people waiting their turn to go into the diner on the freezing cold (12C, drizzle, wind).`}</p>
    <p>{`I spent more than two hours cycling around in a sort of drunk man pattern, as you can see on the `}<a parentName="p" {...{
        "href": "http://runkeeper.com/user/swizec/activity/46686102"
      }}>{`runkeeper map`}</a>{`.`}</p>
    <p>{`Another thing that I learnt is that no matter how fine you feel, an hour of sleep isn't very conductive to general productivity of the following day. It doesn't help if the hour of sleep comes in the form of a nap on the train from San Francisco to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{` (yes, sans great big bike adventure for those who get the reference :)`}</p>
    <p>{`But I think the time spent wandering around had a better long-term productivity impact than an hour of sleep that one night or ten.`}</p>
    <p>{`I might need to go to bed now even though it's not even midnight yet.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-31-7/swizec/2040"
        }}>{`I learned two things today 31.7`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-learned-two-things-today-2-8/swizec/2059"
        }}>{`I learned two things today 2.8.`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lilmissskullz.wordpress.com/2011/08/03/yawn-wow-i-actually-feel-like-waking-up-today/"
        }}>{`*`}{`Yawn`}{`*`}{`, Wow I actually feel like waking up today!`}</a>{` (lilmissskullz.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=30895891-238b-4493-a965-31f342eed179",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      